window.PS = window.PS || {};
window.PS.Models      = {};
window.PS.Controllers = {};
window.PS.Services    = {};

module.exports = window.PS;
